import React from 'react';
import { Checkbox, Icon } from 'antd';
import {
  BktGridInjectedUI, BktGridInjectedSpecialText, BktGridInjectedIcons, BktGridInjectedSpecialLink,
} from './styles';

// Some date time is shown in a different manner - e.g. dispatch plan place more focus on time
// than date, but date needs to be shown since they may not happen on the exact same day.
export const emphasizeTimeForDateTime = ({ cellData }) => {
  const dateTime = cellData ? cellData.split(' ') : ['', ''];
  return (
    <BktGridInjectedUI
      title={cellData}
      style={{ lineHeight: 1, display: 'block' }}
    >
      {dateTime[1].replace(':00', '')}
      <br />
      <BktGridInjectedUI color="greyscale.2">
        <small>{dateTime[0]}</small>
      </BktGridInjectedUI>
    </BktGridInjectedUI>
  );
};

export const showCellWithSimilarHighlight = (
  { cellData, rowIndex, dataKey }, useSimilarMatches,
) => {
  const foundDiffer = useSimilarMatches[rowIndex]
    .find(col => (col === dataKey));

  if (foundDiffer) {
    return (
      <BktGridInjectedSpecialText
        title={cellData}
        color="clientPrimary"
      >
        {cellData}
      </BktGridInjectedSpecialText>
    );
  }

  return <span title={cellData}>{cellData}</span>;
};

export const showScenarioAsLink = (
  { cellData, rowIndex, rowData }, onSelect, column,
) => {
  if (!rowData.fromDate && column.showEditIcon)  return <span title={cellData}>{cellData}</span>;
  return (
    // and I am aware hard coding the class here is as ugly as f**ed but...time.
    <BktGridInjectedUI
      {...rowData.archived && { className: 'DCRPArchivedData' }}
      onClick={() => onSelect({ rowData, col: column })}
    >
      <BktGridInjectedSpecialLink title={cellData}>
        {cellData}
        <BktGridInjectedUI pl="1">
          {column.showEditIcon && <i className="pencil icon" />}
        </BktGridInjectedUI>
      </BktGridInjectedSpecialLink>
    </BktGridInjectedUI>
  );
};

/* eslint no-underscore-dangle: 0 */
// If requires adding a custom UI in BktGrid, please replace with an object with two props
// - customUI: type of UI been injected
// - value: the original displayed value.
export const injectUIViaObj = (cell, col, row, originRow, onSelect, checkedState) => {
  const { customUI, className, value } = cell;
  const rowData = { ...row };
  delete rowData.__FUNC_COLUMN;
  switch (customUI) {
    case 'customCheckbox':
      return (
        <BktGridInjectedUI ml="1" className={className}>
          <Checkbox
            {...checkedState[rowData.id] ? { checked: true } : { checked: false }}
            onChange={e => onSelect({
              rowData,
              originRow,
              col,
              checked: e.target.checked,
            })}
          />
        </BktGridInjectedUI>
      );

    case 'minusButton':
      return (
        <BktGridInjectedUI color="#a00" ml="1" className={className}>
          <Icon
            type="minus-circle"
            theme="filled"
            onClick={() => onSelect({
              rowData,
              col,
              checked: false,
            })}
          />
        </BktGridInjectedUI>
      );

    case 'useDeltaSymbol':
      return (
        <BktGridInjectedSpecialText
          color={(value > 0) ? 'compareArrowUp' : 'compareArrowDown'}
          className={className}
        >
          <b>
            {Math.abs(value)}
            <BktGridInjectedIcons
              ml="1"
              type={`arrow-${
                ((value > 0) && 'up')
                || ((value < 0) && 'down')
              }`}
            />
          </b>
        </BktGridInjectedSpecialText>
      );

    default:
      return <span className={className} title={cell.value}>{cell.value}</span>;
  }
};

export const injectCustomUI = (
  {
    cellData, columnData, rowData,
  }, originRow, onSelect, checkedState,
) => {
  if (
    typeof cellData === 'object'
    && cellData !== null
    && cellData.customUI
  ) {
    return injectUIViaObj(
      cellData, columnData, rowData, originRow,
      onSelect, checkedState,
    );
  }

  return cellData;
};
